"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
function processMessage(message) {
    var isSystem = !!message.t;
    var time = moment_1["default"](message.ts);
    var ts_formatted = time.format('HH:mm');
    var ts_date_formatted = time.format('MMMM, DD');
    if (lodash_1["default"].isDate(message.ts))
        message.ts = message.ts.toISOString();
    var fields = lodash_1["default"].get(message, 'attachments[0].fields', []);
    var typeObj = lodash_1["default"].find(fields, { title: 'type' });
    var messageType = lodash_1["default"].get(typeObj, 'value');
    var type = '';
    if (messageType)
        type = messageType;
    return Object.assign(message, {
        isSystem: isSystem,
        ts_formatted: ts_formatted,
        ts_date_formatted: ts_date_formatted,
        type: type
    });
}
exports["default"] = processMessage;
